import styled from 'styled-components';

export const LoadingPageContainer = styled.main`
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
`;

export const LogoContainer = styled.div`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;

  svg {
    > * {
      stroke: ${({ theme }) => theme.yoga.colors.primary} !important;
    }
  }
`;
